import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  message,
  Modal,

  Typography,
  Steps,
  Icon
} from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import _ from 'lodash';
import { platformApi } from '../../../../api';
import WrappedInsuranceDataForm from './InsuranceData';
import WrappedInsuranceContactsForm from './InsuranceContacts';
import { setConfig } from 'react-hot-loader';


const { Step } = Steps;
const { Text } = Typography;

function InsuranceMasterForm({
  open, close, values,emitData,
  editable, setValues,
  setCount, count,
  setDelData, delData,
  setBankDelData, delbankData,
  supData, setSupData
}) {
  const ChildRef = useRef();
  const ClearRef = useRef();

  const [current, setCurrent] = useState(0);
  const [data, setData] = useState({})
  const [error, setError] = useState({});
  const [logo, setLogo] = useState();

  const icons = [
    <Icon style={{ fontSize: "1rem" }} type="home" key={1}/>,
    <Icon style={{ fontSize: "1rem" }} type="contacts" key={2}/>,
    <Icon style={{ fontSize: "1rem" }} type="bank" key={3}/>
  ];
  const steps = [
    { id: 1, title: "Insurance Data" },
    { id: 2, title: "Insurance Contacts" },
  ];

  const [confirmLoading, setConfirmLoading] = useState(false);

  useEffect(() => {
    if (values) {
      setLogo(values.logo)
      setData(values)
    }
  }, [values])
  useEffect(() => {
    if (supData) {
      platformApi.get(`/api/Insurance/${supData}`)
        .then((res) => {
          let { data } = res
          if (data.code === 200) {
            let { response } = data;
            if (response.code === 200) {
              setData(response.data)
            }
          } else {
            message.error('Cannot fetch Insurance Data');
          }
        })
        .catch((err) => {
          console.error('Insurance fetch error', err);
          message.error('Cannot fetch Insurance Data');
        });
    }
  }, [supData])


  const forms = [
    <WrappedInsuranceDataForm
    key={1}
      data={data}
      setData={setData}
      logo={logo}
      setLogo={setLogo}
      editable={editable}
      validityRef={ChildRef}
      clearRef={ClearRef}
      error={error}
      setError={setError}
    />,
    <WrappedInsuranceContactsForm
    key={2}
      data={data}
      setData={setData}
      values={values}
      editable={editable}
      validityRef={ChildRef}
      clearRef={ClearRef}
      error={error}
      setError={setError}
      setDelData={setDelData}
      delData={delData}
    />

  ]


  const clearFields = () => {
    if (!supData) {
      setData({});
      setCurrent(0);
      ClearRef.current();
      if (setValues) setValues(null);
      if (setDelData) setDelData([]);
      close()
      setError({})
    }
    else {
      setData({});
      setCurrent(0);
      ClearRef.current();
      close()
      setError({})
    }
  };

  const handleSubmit = () => {
    data.logo=logo;

    if (!values || !values.id) {
      setConfirmLoading(true);
      if (data.address) {
        if (data.address.country) data.address.country = data.address.country.id;
        if (data.address.state) data.address.state = data.address.state.id;
        if (data.address.district) data.address.district = data.address.district.id;
      }

      platformApi.post('/api/Insurance', data)
        .then((res) => {
          const success = res?.data?.response?.code === 200;

    if (success) {
      const previousData = res.data.response.data;
       close(); 
       clearFields();
      message.success("Insurance Created Successfully");
      emitData && emitData();
    } else {
      message.error("Insurance Data not Uploaded");
    }
         
        })
        .catch((err) => {
          message.error('Insurance Data not Uploaded');
          console.error('Insurance creation Error:', err);
        });
    } else if (editable) {
      data.id = values.id;
      if (data.address) {
        if (data.address.country) data.address.country = data.address.country.id;
        if (data.address.state) data.address.state = data.address.state.id;
        if (data.address.district) data.address.district = data.address.district.id;
      }
      if (data.GSTIN === undefined) {
        data.GSTIN = ''
      }
      platformApi.put(`/api/Insurance/${values.id}`, data)
        .then((res) => {
          if (res.data.response.code === 200) {
            close();
            message.success('Insurance Saved Successfully');
            emitData && emitData();
            clearFields();
          } else {
            message.error('Insurance save Failed');
          }
        })
        .catch((err) => {
          message.error('Insurance Not Saved');
        });
    }

    setConfirmLoading(false)
  };

  return (
    <Modal
    key={1}
      width="60%"
      confirmLoading={confirmLoading}
      title="Insurance Master"
      visible={open}
      onCancel={() => {
        clearFields();
      }}
      footer={[
      <Button
        onClick={() => {
          current > 0 ? setCurrent(current - 1) : clearFields();
        }}
        key={2}
      >
        {current > 0 ? "Previous" : "Cancel"}
      </Button>,

      <Button
      key={3}
        onClick={() => {
          if (ChildRef.current()) {
            if (current < steps.length - 1) { 
              // Still has next step
              setCurrent(current + 1);
            } else {
              editable ?  handleSubmit() : clearFields() ;
            }
          }
        }}
        type="primary"
      >
        {current < steps.length - 1 
          ? "Next" 
          : (editable ? "Save" : "Cancel")}
      </Button>
    ]}

    >
      <div>
        <Steps size="small" type="navigation" current={current}>
          {steps.map((step, index) => (
            <Step
              key={step.id}
              icon={icons[index]}
              title={<Text>{step.title}</Text>}
            />
          ))}
        </Steps>
        <div>{forms[current]}</div>

      </div>
    </Modal>
  );
}
export default InsuranceMasterForm;
